import React from "react";

type OurWorkCultureCardProps = {
  title: string;
  desc: string;
  icon: React.ReactElement | null;
};

const OurWorkCultureCard: React.FC<OurWorkCultureCardProps> = ({
  title,
  desc,
  icon,
}) => {
  return (
    <div className=" w-full mx-auto lg:h-64 lg:w-96 p-2 flex items-center gap-2 md:gap-4 bg-backgroundColor mb-4 md:mb-10">
      <div className=" hidden md:flex">{icon}</div>
      <div className=" ">
        <h2 className=" font-CrimsonText font-bold text-xl md:text-3xl text-primaryColor">
          {title}
        </h2>
        <p className=" font-CrimsonText font-normal text-sm md:text-base text-justify text-textColor">
          {desc}
        </p>
      </div>
    </div>
  );
};

export default OurWorkCultureCard;
